module.exports = __webpack_public_path__ + "img/07.125301e7.jpg";